export default {_name:'Text.Simple',module:'Field',view:'Element/Text',options:{color:'textPrimary',xs:'auto',ms:'auto'}}